import { Flex, Text } from '@chakra-ui/react';
import { faBookSparkles } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  Button,
  FormFeedback,
  Input,
  Modal,
  useToast
} from '@morressier/alembic';
import { focusIssueGuidelineValidator } from '@publishing-engine/domain/validation';
import { SubmitHandler, useForm } from 'react-hook-form';
import { updateFocusIssueGuidelines } from 'src/api/mutations';
import { FieldLabel } from 'src/components/Field';
import ListView from 'src/layouts/ListView';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  journalId: string;
  guidelineLink: string | undefined;
}
interface IFormData {
  guidelineLink: string;
}

const FocusIssueGuidelinesModal: React.FC<Props> = ({
  isOpen,
  onClose,
  journalId,
  guidelineLink
}) => {
  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      guidelineLink: guidelineLink ?? ''
    },
    resolver: zodResolver(focusIssueGuidelineValidator)
  });
  const UpdateFocusIssueGuidelinesMutation =
    updateFocusIssueGuidelines(journalId);

  const toast = useToast();
  const onSubmit: SubmitHandler<IFormData> = async data => {
    const { guidelineLink } = data;
    const res = await UpdateFocusIssueGuidelinesMutation.mutateAsync(
      guidelineLink
    );
    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: `Common Guidelines Link Saved`
      });

      return onClose();
    }
    toast({
      variant: 'error',
      title: 'Error Updating Common Guidelines Link',
      description: res.message
    });
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width={{ base: 'calc(100vw - 16px)', md: '650px' } as any}
      closeButtonProps={{
        hidden: true
      }}
    >
      <ListView>
        <ListView.Title>
          <Flex flexDirection="column" gap={4} alignItems="flex-start">
            <FontAwesomeIcon icon={faBookSparkles} fontSize="42px" />
            <Text textStyle="headingGroup">Manage Common Guidelines</Text>
          </Flex>
        </ListView.Title>

        <ListView.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Flex flexDirection="column" gap={4}>
              <FieldLabel
                label="Link to Common Guidelines"
                subText=""
                isRequired
              />
              <Input
                {...register('guidelineLink')}
                isInvalid={!!formState.errors.guidelineLink?.message}
                placeholder="Enter link to Common Guidelines"
              />
              {formState.errors.guidelineLink?.message ? (
                <FormFeedback variant="error">
                  {formState.errors.guidelineLink.message}
                </FormFeedback>
              ) : null}

              <Flex gap={2} justifyContent="flex-end" marginTop={3}>
                <Button variant="secondary" onClick={onClose}>
                  Cancel
                </Button>
                <Button type="submit" variant="primary">
                  Save Changes
                </Button>
              </Flex>
            </Flex>
          </form>
        </ListView.Body>
      </ListView>
    </Modal>
  );
};

export default FocusIssueGuidelinesModal;
